<template>
  <div>
    <SearchBar @search-clicked="searchClicked"></SearchBar>
    <CTableWrapper ref="table" hover striped :caption="$t('users')" :items="items" :actions="actions" :pages="pages" :fields="fields" clickable-rows @row-clicked="rowClicked" @action-clicked="actionClicked" @update-requested="updateItemsRequested" :sorter="{external: true}" :sorterValue="sorterValue" @sorter-value-changed="sorterValueChanged" :loading="loading">
    </CTableWrapper>
    <UserPopUp :user="selectedUser" @closeConfirmRequested="showUserPopUp = false" v-model="showUserPopUp"></UserPopUp>
  </div>
</template>
 
<script>
import { mapState, mapActions } from 'vuex'
import CTableWrapper from "@/controls/PaginatedTable.vue";
import SearchBar from "@/controls/SearchBar.vue";
import router from '@/router';
import InputGetList from "@/classes/InputGetList";
import i18n from '@/helpers/i18n';
import { convertToPascalCase } from "@/helpers/utils.js";
import UserPopUp from "@/controls/popups/UserPopUp.vue";

export default {
  components: { CTableWrapper, SearchBar, UserPopUp },
  data () {
    return {
      currentPage: 1,
      searchText: '',
      itemsPerPage: localStorage.itemsPerPage ?? 10,
      fields: [
        { key: 'firstName', label: i18n.t('firstName'), sortable: true },
        { key: 'lastName', label: i18n.t('lastName'), sortable: true },
        { key: 'email', label: i18n.t('email'), sortable: true },
      ],
      actions: [
        { key: 'view', label: i18n.t('view') },
        { key: 'toggleLockout', label: i18n.t('changeStatus') },
      ],
      sorterValue: { column: 'id', asc: true },
      loading: false,
      showUserPopUp: false,
      selectedUser: null
    }
  },
  computed: {
    ...mapState('users', ['getUsersOutput']),
    ...mapState('users', ['deleteUserByIdOutput']),
    ...mapState('users', ['toggleLockUserOutput']),
    usersInfo: function() {
      return this.getUsersOutput ? this.getUsersOutput : null;
    },
    items: function()
    {
      var result = [];

      if(this.usersInfo && this.usersInfo.data)
      {
        result = this.usersInfo && this.usersInfo.data;
        result.forEach(user => {
          if(user.lockoutEnd)
          {
            user['_classes'] = "locked-out";
          }
        });
      }

      return result;
    },
    pages: function()
    {
      return this.usersInfo ? this.usersInfo.totalPages : 1;
    }
  },
  mounted: function()
  {
    this.updateItemsRequested(1, this.itemsPerPage);
  },
  methods: {
    ...mapActions('users', ['getUsers']),
    ...mapActions('users', ['toggleLockUser']),
    rowClicked (item, index) {
      this.$router.push({name: "UsersEdit", query: { id: item.id }, params: { name: item.name } });
    },
    actionClicked(item, action){
      switch(action.key)
      {
        case 'view':
        {
          this.selectedUser = item;
          this.showUserPopUp = true;
          break;
        }
        case 'toggleLockout':
        {
          if(item.lockoutEnd)
          {
            if(confirm(this.$i18n.t('confirmUnlock'))){
              this.toggleLockUser(item.id);
            }
          }
          else
          {
            if(confirm(this.$i18n.t('confirmLock')))
            {
              this.toggleLockUser(item.id);
            }
          }
          break;
        }
        default:
        {
          throw "The provided action is not supported!"; 
        }
      }
    },
    updateItemsRequested(currentPage, itemsPerPage)
    {
      this.currentPage = currentPage;

      //Make request
      this.loading = true;
      this.itemsPerPage = itemsPerPage;

      var input = new InputGetList(itemsPerPage, currentPage, this.searchText, this.sorterValue.asc ? 1 : 2, convertToPascalCase(this.sorterValue.column));
      
      this.getUsers(input); 
    },
    searchClicked(searchText)
    {
      this.searchText = searchText;
      this.$refs.table.reset();

      this.updateItemsRequested(1, this.itemsPerPage);
    },
    sorterValueChanged(value)
    {
      this.sorterValue = value;
    }    
  },
  watch:
  {
    sorterValue:
    {
      handler: function(val)
      {
        this.updateItemsRequested(1, this.itemsPerPage);
      },
      deep: true // Watch for changes on the properties
    },
    getUsersOutput: function(val)
    {
      if(val != null)
      {
        this.loading = false;
      }
    },
    toggleLockUserOutput: function(val)
    {
      this.loading = val === null;
      if(val !== null)
      {
        this.updateItemsRequested(this.currentPage, this.itemsPerPage);
      }
    }
  }
}
</script>

 
<style>
th
{
  border-top: none !important;
}

tr
{
  cursor: pointer;
}

.status-button
{
  border: none;
  padding: 0;
  text-decoration: underline;
  color: #321fdb;
}

.locked-out
{
  background-color: darkred !important;
  color: white;
}
</style> 